import React, { useState } from 'react';
import axios from 'axios';
import SignInForm from './SignInForm';


const SignUpForm = () => {
    const [formSubmit, setFormSubmit] = useState(false);
    const [pseudo, setPseudo] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [controlPassword, setControlPassword] = useState('');
    const [phone, setPhone] = useState('');

    const handleRegister = async (e) => {
        e.preventDefault();
        const conditions = document.getElementById('conditions');
        const pseudoError = document.querySelector('.pseudo.error');
        const emailError = document.querySelector('.email.error');
        const passwordError = document.querySelector('.password.error');
        const passwordConfirmError = document.querySelector('.password-confirm.error');
        const conditionsError = document.querySelector('.conditions.error');
        const phoneError = document.querySelector('.phone.error');

        passwordConfirmError.innerHTML = '';
        conditionsError.innerHTML = '';

        if(password !== controlPassword || !conditions.checked) 
        {
            if(password !== controlPassword)
                passwordConfirmError.innerHTML = 'Les mots de passe ne correspondent pas';
            if(!conditions.checked)
                conditionsError.innerHTML = 'Veuillez valider les conditions générales'
        }

        else {
            await axios({
                method: 'post',
                url: `${process.env.REACT_APP_API_URL}/api/user/register`,
                data: {
                    pseudo,
                    email,
                    password,
                    phone
                }
            })
            .then((res) => {
                if(res.data.errors) {
                    pseudoError.innerHTML = res.data.errors.pseudo;
                    emailError.innerHTML = res.data.errors.email;
                    passwordError.innerHTML = res.data.errors.password;
                    phoneError.innerHTML = res.data.errors.phone;
                    console.log(res.data);
                    
                }
                else {
                    setFormSubmit(true)
                }
            })
            .catch((err) => console.log(err));
        }
    }

    return (
        <>
        {formSubmit ? (
            <>
            <p className='signUpConfirm'>Vous pouvez maintenant vous identifier : </p>
            <SignInForm />
            </>
        ) : (
            <form action='' onSubmit={handleRegister} id='signUpForm'>
            <label htmlFor='pseudo'>Pseudo</label><br/>
            <input type='text' name='pseudo' id='pseudo' onChange={(e) => setPseudo(e.target.value)} value={pseudo} /> 
            <div className="pseudo error"></div><br/>
            <label htmlFor='email'>Email</label><br/>
            <input type='text' name='email' id='email' onChange={(e) => setEmail(e.target.value)} value={email} /> 
            <div className="email error"></div><br/>
            <label htmlFor='phone'>Téléphone</label><br/>
            <input type='tel' name='phone' pattern="[0-9]{10}" id='phone' onChange={(e) => setPhone(e.target.value)} value={phone}></input>
            <div className="phone error"></div><br/>
            <label htmlFor='password'>Mot de passe</label><br/>
            <input type='password' name='password' id='password' onChange={(e) => setPassword(e.target.value)} value={password} /> 
            <div className="password error"></div><br/>
            <label htmlFor='password'>Confirmation du mot de passe</label><br/>
            <input type='password' name='password' id='passwordConf' onChange={(e) => setControlPassword(e.target.value)} value={controlPassword} /> 
            <div className="password-confirm error"></div><br/>
            <input type='checkbox' id='conditions' />
            <label className='conditions' htmlFor='conditions'>
                J'accepte les <a href='/' target='_blank' rel='noreferror'>conditions générales</a>
            </label><br/>
            <div className="conditions error"></div>
            <input id='submit' className='button' type='submit' value='valider inscription' />
        </form>
        )}
        </>
    );
};

export default SignUpForm;